/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import {
    ICheckoutTermsAndConditions,
    ICheckoutTermsAndConditionsError,
    ICheckoutTermsAndConditionsViewProps
} from '@msdyn365-commerce-modules/checkout/src/modules/checkout-terms-and-conditions/./checkout-terms-and-conditions';

export interface ICheckoutTermsAndConditionsExtended extends ICheckoutTermsAndConditions {
    checkoutPolicy: any;
}

const TermsAndCondition: React.FC<ICheckoutTermsAndConditionsExtended> = ({
    termsAndConditionAcceptance,
    checkBox,
    description,
    checkoutPolicy
}) => {
    return (
        <Node {...termsAndConditionAcceptance}>
            {checkBox}
            {description}
            {checkoutPolicy && <a href={checkoutPolicy.URL}>{checkoutPolicy?.DESCRIPTION}</a>}
        </Node>
    );
};

const ErrorMessage: React.FC<ICheckoutTermsAndConditionsError> = ({ error, title, message }) => {
    return (
        <Node {...error}>
            {title}
            {message}
        </Node>
    );
};

const CheckoutTermsAndConditionsView: React.FC<ICheckoutTermsAndConditionsViewProps> = props => {
    const { checkoutTermsAndConditions, viewState, termsAndConditionsContent, errorMessage, saveButton, editButton, cancelButton } = props;

    // @ts-ignore
    const policies = props.data.policy.result;
    // @ts-ignore
    const checkoutPolicy = policies?.find(policy => policy.USEFORCHECKOUT === 1);

    return (
        // TODO: All wrapper div should be provided by viewProps. Once SDK provide the sln, update markup.
        <Module {...checkoutTermsAndConditions}>
            {viewState.isError && errorMessage && <ErrorMessage {...errorMessage} />}
            <TermsAndCondition {...termsAndConditionsContent} checkoutPolicy={checkoutPolicy} />
            {viewState.isShowSaveButton && saveButton}
            {viewState.isShowEditButton && editButton}
            {viewState.isShowCancelButton && cancelButton}
        </Module>
    );
};

export default CheckoutTermsAndConditionsView;
